<div *ngIf="displayScreen">
    <div class="container-fluid">
        <div class="col-md-12 ms-3 mb-3 me-3 mt-1">
            <mat-tab-group mat-stretch-tabs animationDuration="0ms" (selectedIndex)="selectedTabIndex"
                (selectedTabChange)="onTabChanged($event)">
                <mat-tab label="New Report Period">
                    <div class="row mt-2" style="margin-bottom: 50px">
                        <div class="flex-row mt-2">
                            <app-newreport-period></app-newreport-period>
                        </div>
                    </div>
                </mat-tab>

            </mat-tab-group>
        </div>
    </div>

</div>

<div *ngIf="displayUnauthorized">
    <div class=" container unauthorized" *ngIf="displayUnauthorized">
        <p></p>
        <p style="color: red;">You do not have a role assigned to access this Application.</p>
        <p>Please raise a request using
            <a style="color: #2688Da; text-decoration:underline"
                href="https://ep.idm.toyota.com/identityiq/home.jsf">SailPoint</a>.
            Refer to the <span style="color: #2688Da; text-decoration:underline; cursor:pointer">User Guide</span>
            for more details.
        </p>
        <p style="color: #2688Da; text-decoration:underline; cursor: pointer;" (click)="cancelNullGuidAssume()"
            (keydown)="cancelNullGuidAssume()" *ngIf="cancelAssumedUser">Cancel Assume</p>
    </div>
</div>